import templateUrl from 'emun.on-demand/fabric-designer.htm'
import resolve from 'ioc/resolve'
import basicController from 'servicestack/basic.controller.properties'
import Design from 'emun.on-demand/lib/design'
import ServiceBus from 'servicestack/service-bus'
import httpPoller from 'webutils/http-poller.service'
import modals from 'webmodals/modals'


class FabricDesignerController {
    constructor($state, $stateParams) {
        basicController(this)
        const $ctrl = this;
        Object.assign($ctrl, { $state }, $stateParams);
        console.warn('$ctrl.designUrl', $ctrl.designUrl);
        $ctrl.bus = new ServiceBus();
    }

    $onInit() {
        const $ctrl = this;
    }

    designerReady(designer) {
        let $ctrl = this;
        let defaultDesign = new Design({ height: 3000, width: 3000, overscan: 0 });
        $ctrl.designer = designer;
        designer.mode = 'Inline';
        console.log('$ctrl.designUrl', $ctrl.designUrl);
        let deferred = resolve('$q').defer();
        let url = $ctrl.designId ? `QueryMedia/${$ctrl.designId}.json` : $ctrl.designEuid ? `QueryMedia/euid/${$ctrl.designEuid}.json` : null;
        if (url) {
            url += '?Fields=Id,Euid,Label,Tags,CreatedOn,Description,Height,Width,CreatedBy,Url';
            $ctrl.bus.send(url).then(qmr => {
                if (qmr.data.results.length === 0) {
                    deferred.resolve(defaultDesign);
                }
                else {
                    let design = new Design(qmr.data.results[0]);
                    deferred.resolve(design);

                }
            });
        } else if ($ctrl.designUrl) {
            console.debug('$ctrl.designUrl', $ctrl.designUrl);
            let design = new Design({ url: $ctrl.designUrl });
            deferred.resolve(design);
        } else {
            deferred.resolve(defaultDesign);
        }

        deferred.promise.then(d => {
            $ctrl.design = d;
            d.anythingGoes = true;
            console.debug('$ctrl.design', $ctrl.design.width, $ctrl.design.height, $ctrl.design);
            $ctrl.bus.read('QueryMediaTagKinds.json').then(res => {
                res.data.results.forEach(r => $ctrl.addTagKind(r.tagKind));
            });
            designer.designs = [d];
            designer.activate(d);
            return designer;
        })

        return deferred.promise;
    }

    submit() {
        let $ctrl = this;
        let design = $ctrl.designer.design;
        let replacePredecessor = true;

        modals.confirm(`Please confirm that you are ready to save your design.`, 'Saving ' + design.label).result.then(() => {
            $ctrl.designer.status = 'saving';
            $ctrl.uploading = {};
            design.saveJson = true;
            design.validateAndSave(replacePredecessor).then(
                response => {
                    $ctrl.designer.isDirty = false;
                    let designId = response.id || design.id;
                    console.debug('design created', response, design);
                    $ctrl.onSaved({ design });
                    $ctrl.$state.transitionTo("od-media", { designId });
                    console.debug('transitionTo', response);
                },
                response => console.error('could not upload media', response),
                progressEvent => {
                    $ctrl.uploading.total = progressEvent.total;
                    $ctrl.uploading.loaded = progressEvent.loaded;
                    $ctrl.uploading.percentage = parseInt(100.0 * progressEvent.loaded / progressEvent.total);
                }).finally(() => {
                    $ctrl.uploading = false;
                    $ctrl.designer.status = 'ready';
                });
        });
    }

    addTagKindPrompt() {
        modals.prompt('Add Tag Kind...')
            .result
            .then(tk => this.addTagKind(tk));
    }

    addTagKind(tk) {
        if (!this.design.tags)
            this.design.tags = {};
        if (!this.design.tags[tk])
            this.design.tags[tk] = [];
    }

    $onDestroy() {
        this.designer.dispose();
    }
}

let FabricDesignerComponent = {
    bindings: {
        designId: '@',
        designUrl: '@',
        pickRatioOnLoad: '@',
        onSaved: '&'
    },
    controller: FabricDesignerController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default FabricDesignerComponent;